module.exports = "/dist/7394ca9f8315fedfec68ab850157122b.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700italic.woff2
// module id = 163
// module chunks = 0